module.exports = __webpack_public_path__ + "images/a4541e840476cf127da561df33160fbb.png";